function handleScrollTo(targetElement) {
  if (targetElement) {
    const isSmoothScrollSupported =
        'scrollBehavior' in document.documentElement.style,
      header_height =
        document.querySelector('header.header')?.offsetHeight ?? 0;
    //targetElement.scrollIntoView({ behavior: 'smooth' });

    if (isSmoothScrollSupported) {
      window.scroll({
        top: targetElement.offsetTop - header_height,
        left: 0,
        behavior: 'smooth',
      });
    } else {
      window.scroll(0, targetElement.offsetTop - header_height);
    }
  }
}

function handleAnchorClick(e) {
  const targetId = e.currentTarget.getAttribute('href').split('#')[1],
    targetElement = document.getElementById(targetId);

  if (targetElement) {
    e.preventDefault();

    handleScrollTo(targetElement);

    const url = new URL(window.location);
    url.hash = '#' + targetId;
    window.history.pushState({}, '', url);
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (window.location.hash.length > 1) {
    const targetId = window.location.hash.split('#')[1];

    handleScrollTo(document.getElementById(targetId));
  }

  Array.from(document.querySelectorAll('a[href*="#"]'))
    .filter((a) => {
      return (
        (a.getAttribute('href').startsWith('#') ||
          a.href.startsWith(`${location.href}#`)) &&
        !a.hasAttribute('data-slider')
      );
    })
    .forEach((el) => {
      el.removeEventListener('click', handleAnchorClick);

      el.addEventListener('click', handleAnchorClick);
    });
});
